package com.hyperether.goodjob.scenes.user.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Divider
import androidx.compose.material.Icon
import androidx.compose.material.OutlinedButton
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextAlign
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.clear_all
import com.hyperether.goodjob.resources.confirm
import com.hyperether.goodjob.resources.filter
import com.hyperether.goodjob.resources.role
import com.hyperether.goodjob.resources.skill
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.team
import com.hyperether.goodjob.scenes.components.FilterSectionMobile
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.toggleSelection
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.scenes.user.UserViewModel
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun FilterUsersDialog(
    cityList: List<String>,
    roleList: List<String>,
    teamList: List<String>,
    statusList: List<String>,
    skillList: List<String>,
    viewModel: UserViewModel,
    isMobileView: Boolean,
    onDismiss: () -> Unit,
    onApply: (Set<String>, Set<String>, Set<String>, Set<String>, Set<String>) -> Unit
) {
    if (isMobileView) {
        Box(modifier = Modifier.fillMaxSize()) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .clickable(
                        onClick = {},
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() })
            ) {
                val scrollState = rememberScrollState()
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .align(Alignment.Center)
                        .background(Color.White)
                        .verticalScrollbar(scrollState)
                        .verticalScroll(scrollState)
                        .disableMouseDragScrollOnWeb()
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            painter = painterResource(Res.drawable.back_arrow),
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .weight(1f)
                                .offset(x = (-30).toScaleDp())
                                .align(Alignment.CenterVertically)
                                .clickable {
                                    onDismiss()
                                }
                        )
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = 20.toScaleSp(),
                                modifier = Modifier
                                    .weight(3f)
                                    .align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = 14.toScaleSp(),
                                color = BlueApp,
                                modifier = Modifier
                                    .weight(1f)
                                    .align(Alignment.CenterVertically)
                                    .clickable {
                                        viewModel.clearFilterValues()
                                    }
                            )
                        }
                    }
                    Divider(
                        modifier = Modifier.height(2.toScaleDp())
                            .background(Color.LightGray.copy(alpha = 0.1f))
                    )

                    Column(
                        modifier = Modifier
                            .padding(start = 16.toScaleDp())
                            .weight(1f)
                            .verticalScroll(rememberScrollState())
                            .disableMouseDragScrollOnWeb()
                    ) {
                        if (roleList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.role),
                                options = roleList,
                                selectedOptions = viewModel.selectedRoles.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedRoles.value =
                                        toggleSelection(viewModel.selectedRoles.value, value)
                                }
                            )
                        }

                        if (statusList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.status),
                                options = statusList,
                                selectedOptions = viewModel.selectedStatuses.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedStatuses.value =
                                        toggleSelection(viewModel.selectedStatuses.value, value)
                                }
                            )
                        }

                        if (cityList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.city),
                                options = cityList,
                                selectedOptions = viewModel.selectedCities.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedCities.value =
                                        toggleSelection(viewModel.selectedCities.value, value)
                                }
                            )
                        }

                        if (teamList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.team),
                                options = teamList,
                                selectedOptions = viewModel.selectedTeams.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedTeams.value =
                                        toggleSelection(viewModel.selectedTeams.value, value)
                                }
                            )
                        }

                        if (skillList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.skill),
                                options = skillList,
                                selectedOptions = viewModel.selectedSkills.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedSkills.value =
                                        toggleSelection(viewModel.selectedSkills.value, value)
                                }
                            )
                        }
                    }
                    FilledButton(
                        onClick = {
                            onApply(
                                viewModel.selectedCities.value,
                                viewModel.selectedRoles.value,
                                viewModel.selectedTeams.value,
                                viewModel.selectedStatuses.value,
                                viewModel.selectedSkills.value
                            )
                            onDismiss()
                        },
                        modifier = Modifier.padding(
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp(),
                            top = 30.toScaleDp(),
                            bottom = 20.toScaleDp()
                        ).fillMaxWidth(),
                        text = stringResource(Res.string.confirm),
                        isEnabled = true,
                    )
                }
            }
        }
    } else {
        Box(modifier = Modifier
            .fillMaxHeight()
            .clickable(
                onClick = {},
                indication = null,
                interactionSource = remember { MutableInteractionSource() }
            )) {
            Box(
                modifier = Modifier
                    .width(370.toScaleDp())
                    .align(Alignment.Center)
                    .shadow(8.toScaleDp(), RoundedCornerShape(12.toScaleDp()))
                    .clip(RoundedCornerShape(12.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                val scrollState = rememberScrollState()
                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        .align(Alignment.Center)
                        .background(Color.White)
                        .verticalScrollbar(scrollState)
                        .verticalScroll(scrollState)
                        .disableMouseDragScrollOnWeb()
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(8.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = 20.toScaleSp(),
                                modifier = Modifier.align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = 14.toScaleSp(),
                                color = BlueApp,
                                modifier = Modifier
                                    .align(Alignment.CenterVertically)
                                    .padding(start = 15.toScaleDp())
                                    .clickableWithPointer {
                                        viewModel.clearFilterValues()
                                    }
                            )
                        }
                        Spacer(modifier = Modifier.weight(1f))

                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .clickableWithPointer {
                                    onDismiss()
                                }
                        )
                    }

                    Column(modifier = Modifier.padding(start = 8.toScaleDp(), end = 8.toScaleDp())) {
                        if (roleList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.role),
                                options = roleList,
                                selectedOptions = viewModel.selectedRoles.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedRoles.value =
                                        toggleSelection(viewModel.selectedRoles.value, value)
                                }
                            )
                        }

                        if (statusList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.status),
                                options = statusList,
                                selectedOptions = viewModel.selectedStatuses.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedStatuses.value =
                                        toggleSelection(viewModel.selectedStatuses.value, value)
                                }
                            )
                        }

                        if (cityList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.city),
                                options = cityList,
                                selectedOptions = viewModel.selectedCities.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedCities.value =
                                        toggleSelection(viewModel.selectedCities.value, value)
                                }
                            )
                        }

                        if (teamList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.team),
                                options = teamList,
                                selectedOptions = viewModel.selectedTeams.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedTeams.value =
                                        toggleSelection(viewModel.selectedTeams.value, value)
                                }
                            )
                        }

                        if (skillList.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.skill),
                                options = skillList,
                                selectedOptions = viewModel.selectedSkills.value,
                                onOptionSelected = { value ->
                                    viewModel.selectedSkills.value =
                                        toggleSelection(viewModel.selectedSkills.value, value)
                                }
                            )
                        }

                    }
                    Spacer(modifier = Modifier.weight(1f))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 16.toScaleDp(), bottom =  20.toScaleDp()),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        OutlinedButton(
                            onClick = {
                                onDismiss()
                            },
                            modifier = Modifier
                                .weight(1f)
                                .height(50.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand),
                            border = BorderStroke(1.toScaleDp(), BlueApp),
                            shape = RoundedCornerShape(50.toScaleDp()),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White,
                                backgroundColor = Color.Transparent
                            )
                        ) {
                            DisableSelection {
                                Text(
                                    text = stringResource(Res.string.cancel),
                                    maxLines = 1,
                                    fontSize = 12.5f.toScaleSp(),
                                    color = BlueApp,
                                )
                            }
                        }
                        Spacer(modifier = Modifier.width(10.toScaleDp()))
                        FilledButton(
                            onClick = {
                                onApply(
                                    viewModel.selectedCities.value,
                                    viewModel.selectedRoles.value,
                                    viewModel.selectedTeams.value,
                                    viewModel.selectedStatuses.value,
                                    viewModel.selectedSkills.value
                                )
                                onDismiss()
                            },
                            text = stringResource(Res.string.confirm),
                            isEnabled = true,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}
